<template>
  <header class="app-content-block-hero" :class="{ fullscreen: data.media && data.media.fullScreenMode }">
    <slot name="heading" :data="data.heading">
      <AppContainer>
        <h1 v-if="data.heading.value" :class="['heading', `heading--${data.heading.textAlign}`]">
          <span :class="{ 'visually-hidden': data.heading.completelyHidden }">{{ data.heading.value }}</span>
        </h1>
        <p v-if="data.heading.tagLine" class="tagline">{{ data.heading.tagLine }}</p>
      </AppContainer>
    </slot>

    <template v-if="data.media">
      <AppHeroImageCarousel
        v-if="data.media.type === 'image_carousel' && data.media.images.length"
        :slides="data.media.images"
        :transition-effect="data.media.transitionEffect"
      />
      <AppHeroImageSingle
        v-else-if="data.media.images.length === 1"
        class="media"
        :media="data.media.images[0].media"
      />
      <AppHeroImageMultiple v-else-if="data.media.images.length" :images="data.media.images" class="media" />
    </template>
  </header>
</template>

<script>
import AppContainer from '@/components/AppContainer.vue';

export default {
  name: 'AppContentBlockHero',
  components: {
    AppContainer,
    AppHeroImageCarousel: () => import('@/components/content-blocks/AppHeroImageCarousel.vue'),
    AppHeroImageSingle: () => import('@/components/content-blocks/AppHeroImageSingle.vue'),
    AppHeroImageMultiple: () => import('@/components/content-blocks/AppHeroImageMultiple.vue'),
  },
  props: {
    uid: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.app-content-block-hero {
  &.fullscreen {
    --app-header-nav-height: 60px;

    position: relative;
    display: flex;
    min-height: 80vh;
    padding-bottom: 40px;
    padding-top: calc(var(--app-header-nav-height) + 12vh);

    @media (min-width: vars.$mobile-break-point + 1) {
      min-height: 86vh;
    }
    @media (min-width: vars.$tablet-break-point + 1) {
      --app-header-nav-height: 80px;
    }
    @media (min-width: vars.$desktop-lg-1024-break-point + 1) {
      min-height: 89vh;
    }
    @media (min-width: vars.$desktop-xl-1200-break-point + 1) {
      min-height: 92vh;
    }
    @media (min-width: vars.$desktop-xl-1400-break-point + 1) {
      min-height: 100vh;
    }
  }

  .heading {
    font-weight: 700;
    font-size: 22px;
    letter-spacing: 5px;
    text-transform: uppercase;
    color: vars.$c-dark-gray;
    text-align: center;

    &--left {
      text-align: left;
    }

    @media (min-width: vars.$mobile-break-point + 1) {
      font-size: 28px;
    }

    @media (min-width: vars.$tablet-break-point + 1) {
      font-size: 44px;
      letter-spacing: 6px;
    }
  }

  .tagline {
    margin-top: 16px;
    font-size: 16px;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: vars.$c-gray-a2;

    @media (min-width: vars.$tablet-break-point + 1) {
      margin-top: 36px;
      font-size: 20px;
    }
  }

  .media {
    overflow: hidden;
    margin-top: 48px;
  }
}
</style>
